import { useExperiments } from '@wix/fe-essentials-standalone';
import { useRouter } from 'next/router';

import { EXPERIMENTS, LOCALES } from '../constants';
import { useStore } from '../zustand/stores';

const useIsSearchRedirectToContactEnabled = () => {
  const { experiments } = useExperiments({ suspense: false, readOnly: true });
  const { user } = useStore((state) => state.userSlice);
  const { locale } = useRouter();

  if (!user || locale !== LOCALES.EN) {
    return false;
  }

  return experiments.enabled(EXPERIMENTS.SPECS.SEARCH_REDIRECT_TO_CONTACT);
};

export default useIsSearchRedirectToContactEnabled;
